import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaChevronUp from 'react-icons/lib/fa/chevron-up';

import {
    localize,
} from 'wanderu-i18n';
import {
    scrollTo,
} from 'wanderu-utils';

import styles from './BackToTopButton.scss';

const VERTICAL_TRIGGER = 300;

class BackToTopButton extends React.Component {
    static propTypes = {
        buttonClassName: PropTypes.string,
        chevronClassName: PropTypes.string,
        duration: PropTypes.number,
    };

    static defaultProps = {
        buttonClassName: '',
        chevronClassName: '',
        duration: 1000,
    };

    constructor(props) {
        super(props);

        this.state = {
            hideScroll: true,
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this._detectScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._detectScroll);
    }

    _detectScroll = () => {
        const { hideScroll } = this.state;

        if (window.pageYOffset > VERTICAL_TRIGGER && hideScroll) {
            return this.setState(() => ({ hideScroll: false }));
        } if (window.pageYOffset <= VERTICAL_TRIGGER && !hideScroll) {
            return this.setState(() => ({ hideScroll: true }));
        }
    }

    _scrollToTop = () => {
        const { duration } = this.props;
        scrollTo(0, { duration });
    }

    render() {
        const {
            t,
            buttonClassName,
            chevronClassName,
        } = this.props;
        const {
            hideScroll,
        } = this.state;

        if (hideScroll) {
            return null;
        }

        return (
            <div
                aria-label={t('go-back-link')}
                className={classNames(
                    buttonClassName,
                    styles.backToTop,
                )}
                onClick={this._scrollToTop}
                role="button"
            >
                <FaChevronUp
                    className={classNames(
                        chevronClassName,
                        styles.chevron,
                    )}
                />
            </div>
        );
    }
}

export { BackToTopButton };
export default localize(BackToTopButton, ['t'], 'baseApp');
